import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "index"
};
const _hoisted_2 = {
  class: "form"
};
import CustomBar from "@/components/customBar";
import { ref } from "vue";
import { makeOrder } from "@/api/index";
import { usebaseRouter } from "@/utils/hooks";
import PayPwd from "@/components/payPwd";

import { showToast, showConfirmDialog } from 'vant/es';
import 'vant/es/toast/style/index';
import 'vant/es/dialog/style/index';
export default {
  __name: 'index',
  setup(__props) {
    const {
      back
    } = usebaseRouter();
    const childRef = ref();
    const params = ref({
      mobile: '',
      payPasswd: ''
    });
    const handlePwd = pwd => {
      params.value.payPasswd = pwd;
      makeOrder(params.value).then(() => {
        showToast('出库成功');
        back();
      });
    };
    const submit = () => {
      if (!params.value.mobile) return showToast('请输入收货账号');
      showConfirmDialog({
        title: '提示',
        message: '是否确认出库？'
      }).then(() => {
        params.value.payPasswd = '';
        childRef.value.setShow(true);
      });
    };
    return (_ctx, _cache) => {
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(CustomBar), {
        title: "随身仓出库"
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("input", {
        class: "form-input icon4",
        type: "tel",
        maxlength: "11",
        placeholder: "请输入收货账号",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => params.value.mobile = $event)
      }, null, 512), [[_vModelText, params.value.mobile]]), _createVNode(_component_van_button, {
        type: "primary",
        large: "",
        round: "",
        block: "",
        class: "savebtn",
        onClick: submit
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("出库")])),
        _: 1
      }), _createElementVNode("div", {
        class: "hint",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.$router.push('record?type=2'))
      }, "出库记录")])]), _createVNode(_unref(PayPwd), {
        ref_key: "childRef",
        ref: childRef,
        onSuccess: handlePwd
      }, null, 512)], 64);
    };
  }
};